import React, { useEffect, useRef } from 'react';
import { OneTap } from '@vkid/sdk';

function VkAuth() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const oneTap = new OneTap();

    oneTap.render({
      container: containerRef.current,
      onError: (err) => {
        console.error('VK ID error', err);
      },
    });

    return () => {
      oneTap.destroy?.();
    };
  }, []);

  return <div ref={containerRef} />;
}

export default VkAuth;
